// src/components/Login.js
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import './Login.css';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [isSignUp, setIsSignUp] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);

    const { error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    if (error) {
      setError('Erro ao fazer login: ' + error.message);
      return;
    }

    navigate('/home');
  };

  const handleSignUp = async (e) => {
    e.preventDefault();
    setError(null);

    const { error } = await supabase.auth.signUp({
      email,
      password,
    });

    if (error) {
      setError('Erro ao cadastrar: ' + error.message);
      return;
    }

    alert('Usuário cadastrado com sucesso! Faça login para continuar.');
    setIsSignUp(false);
  };

  return (
    <div className="login-container">
      {/* Container para as duas logomarcas lado a lado */}
      <div className="logos-container">
        <img src="/assets/logo1.PNG" alt="Logo 1" className="logo" />
        <img src="/assets/logo2.png" alt="Logo 2" className="logo" />
      </div>
      <h1>{isSignUp ? 'Cadastrar' : 'Login'}</h1>
      <form onSubmit={isSignUp ? handleSignUp : handleLogin}>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Senha"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        {error && <p className="error-message">{error}</p>}
        <button type="submit">{isSignUp ? 'Cadastrar' : 'Entrar'}</button>
      </form>
      <button className="signup-button" onClick={() => setIsSignUp(!isSignUp)}>
        {isSignUp ? 'Já tem uma conta? Faça login' : 'Não tem uma conta? Cadastre-se'}
      </button>
    </div>
  );
}

export default Login;